export default __webpack_public_path__ + "static/media/login.174fadf2.jpeg";